<template>
  <div class="flex flex-col">
    <h2>Franquicias</h2>

    <router-link
      v-if="hasPermission('edit_franchises')"
      :to="{ name: 'franchisesCreateForm' }"
      class="primary-button mx-0 mt-2"
      >Crear Franquicia</router-link
    >

    <custom-search
      class="mt-6 w-[500px]"
      placeholder="Buscar por Nombre ó Franquiciatario"
      v-model="searchText"
      @confirm="search"
      @clear="search"
    />

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white">
        <thead class="text-left">
          <tr class="bg-primary-100">
            <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Franquiciatario</th>
            <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
            <!-- <th class="p-2 ">Cantidad</th>
            <th class="p-2 ">Fecha</th>
            <th class="p-2 ">Razón</th> -->
            <!-- <th class="p-2">Precio</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="franchise in franchises" :key="franchise.id" class="table-row">
            <td class="table-cell">
              {{ franchise.id }}
            </td>
            <td class="table-cell">
              {{ franchise.name }}
            </td>
            <td class="table-cell">
              {{ franchise.franchisee_name }}
              {{ franchise.franchisee_last_name }}
            </td>
            <!-- <td class="p-2  ">
              {{ franchise.quantity_change.toLocaleString() }}g
            </td>
            <td class="p-2  ">
              {{ formatDate(franchise.created_at) }}
            </td>
            <td class="p-2  ">{{ franchise.reason }}</td>
            <td class="p-2 ">
              {{ integerToCurrency(franchise.price) }}
            </td> -->

            <td class="table-cell">
              <div class="flex">
                <router-link
                  :to="{
                    name: 'franchisesDetail',
                    params: { franchiseId: franchise.id },
                  }"
                  class="secondary-button"
                  >Detalle</router-link
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
export default {
  name: "Franchises",

  components: {
    Pagination,
  },

  data() {
    return {
      franchises: null,
      loading: false,
      searchText: "",
      currentPage: 1,
      totalPages: 0,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "franchises");

    this.loadFranchises();
  },

  methods: {
    async loadFranchises() {
      this.loading = true;

      try {
        const response = await api.franchises.getAllWithQueryParams([
          {
            name: "page",
            value: this.currentPage,
          },
          {
            name: "search",
            value: this.searchText,
          },
        ]);
        this.franchises = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadFranchises();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadFranchises();
    },
  },
};
</script>